import React from "react"

const ProvidersContext = React.createContext({})

const { Provider, Consumer } = ProvidersContext

export { Provider, Consumer, ProvidersContext }
